import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpRight: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m.16.16l15.68 15.68V.16z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpRight
